var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8934 8.57141H15.8889C15.8206 8.57141 15.7563 8.60489 15.7161 8.6598L11.9112 13.9044L8.10632 8.6598C8.06614 8.60489 8.00186 8.57141 7.93355 8.57141H6.92909C6.84204 8.57141 6.79114 8.67052 6.84204 8.7415L11.5644 15.2518C11.7358 15.4875 12.0867 15.4875 12.2568 15.2518L16.9791 8.7415C17.0313 8.67052 16.9804 8.57141 16.8934 8.57141Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/DropDownIcon.61a84a1288361915445f35c27ae66320.svg";
export { ForwardRef as ReactComponent };